<template>
  <div class="lower-page plan-information">
    <navbar />
    <div class="lower-mv" :style="lowermv">
      <h2>{{ $t('plan_info') }}</h2>
    </div>

    <section class="wrapper">
      <suspension-notice noticeType="unpaid" v-if="!showCurrentPlan() || failedToPay()" />
      <h3>{{ $t('h3_current-plan') }}</h3>
      <div class="entry-detail-wrapper">
        <div v-html="$t('html_canceled-caution')" v-if="!showCurrentPlan()"></div>
        <dl class="entry-detail-item" v-if="showCurrentPlan()">
          <dt>{{ $t('label_plan-name') }}</dt>
          <dd>{{ currentPlan.name }}</dd>
          <dt>{{ $t('label_amount') }}</dt>
          <dd>{{ toLocaleString(currentPlan.price) }}{{ currentPlan.currency }}{{ $t('label_before-tax') }}</dd>
          <dt>{{ $t('label_contract-term') }}</dt>
          <dd>{{ currentPlan.start_at }} 〜 {{ currentPlan.end_at }}</dd>
          <dt>{{ $t('label_contract-renewal-date') }}</dt>
          <dd>{{ nextAt }}</dd>
        </dl>
        <div class="attention" v-html="$t('html_scheduled-cancel-caution', [currentPlan.end_at])" v-if="scheduledToCancel()" />
      </div>
      <form v-if="showCurrentPlan() || showNextPlan()">
        <div class="submit">
          <button type="button" class="brown_btn" v-on:click="openCustomerPortal" :disabled="!urlLoaded" v-if="showCurrentPlan() && !failedToPay()">
            <span>{{ $t('label_change-plan') }}</span>
          </button>
          <button type="button" class="brown_btn" v-on:click="openInvoice" :disabled="!urlLoaded" v-if="failedToPay()">
            <span>{{ $t('label_payment') }}</span>
          </button>
          <a @click="showModal('about-change-plan')" v-if="showCurrentPlan() && !failedToPay()">{{ $t('label_about-change-plan') }}</a>
        </div>
      </form>
    </section>
    <section class="wrapper" v-if="showNextPlan()">
      <h3>{{ $t('h3_next-plan') }}</h3>
      <div class="entry-detail-wrapper">
        <dl class="entry-detail-item">
          <dt>{{ $t('label_plan-name') }}</dt>
          <dd>{{ nextPlan.name }}</dd>
          <dt>{{ $t('label_amount') }}</dt>
          <dd>{{ toLocaleString(nextPlan.price) }}{{ nextPlan.currency }}{{ $t('label_before-tax') }}</dd>
          <dt>{{ $t('label_contract-term') }}</dt>
          <dd>{{ nextPlan.start_at }} 〜 {{ nextPlan.end_at }}</dd>
          <dt>{{ $t('label_contract-renewal-date') }}</dt>
          <dd>{{ nextPlan.next_at }}</dd>
        </dl>
        <div class="attention" v-html="$t('html_next-plan-caution')" />
      </div>
    </section>
    <section class="wrapper" v-if="listingOptionUrl">
      <h3>{{ $t('h3_carry-business-property') }}</h3>
      <div class="entry-detail-wrapper">
        <dl class="entry-detail-item">
          <dt>{{ $t('label_business-property-slot') }}</dt>
          <dd>{{ $t('format_property-count', [toLocaleString(listing.total_limit)]) }}
            {{ listing.option_limit > 0 ? $t('format_option-content', [$t('format_property-count', [toLocaleString(listing.option_limit)])]) : '' }}
          </dd>
          <dt>{{ $t('label_business-property-count') }}</dt>
          <dd>{{ $t('format_property-count', [toLocaleString(listing.used)]) }}</dd>
          <dt v-if="listing.option_limit > 0">{{ $t('label_option-expiry-date') }}</dt>
          <dd v-if="listing.option_limit > 0">{{ currentPlan.end_at }}</dd>
        </dl>
      </div>
      <form v-if="showCurrentPlan() && !failedToPay()">
        <div class="submit">
          <button type="button" class="brown_btn" v-on:click="openListingOptionCheckout" :disabled="!urlLoaded">
            <span>{{ $t('label_purchase-option') }}</span>
          </button>
          <a @click="showModal('about-business-property-option')">{{ $t('label_about-business-property-option') }}</a>
        </div>
      </form>
    </section>
    <section class="wrapper" v-if="aiTranslatingOptionUrl">
      <h3>{{ $t('h3_ai-translation') }}</h3>
      <div class="entry-detail-wrapper">
        <dl class="entry-detail-item">
          <dt>{{ $t('label_ai-translation-slot') }}</dt>
          <dd><a :href="aiTranslatingUrl">{{ $t('label_view-ai-translation-usage') }}</a></dd>
          <dt v-if="aiTranslating.option_limit > 0">{{ $t('label_option-expiry-date') }}</dt>
          <dd v-if="aiTranslating.option_limit > 0">{{ currentPlan.end_at }}</dd>
        </dl>
      </div>
      <form v-if="showCurrentPlan() && !failedToPay()">
        <div class="submit">
          <button type="button" class="brown_btn" v-on:click="openAiTranslatingOptionCheckout" :disabled="!urlLoaded">
            <span>{{ $t('label_purchase-option') }}</span>
            </button>
          <a @click="showModal('about-ai-translation-option')">{{ $t('label_about-ai-translation-option') }}</a>
        </div>
      </form>
    </section>
    <section class="wrapper" v-if="showCurrentPlan()">
      <h3>{{ $t('h3_ocr') }}</h3>
      <div class="entry-detail-wrapper">
        <dl class="entry-detail-item">
          <dt>{{ $t('label_ai-translation-slot') }}</dt>
          <dd>{{ $t('label_unlimited') }}</dd>
        </dl>
      </div>
    </section>

    <footerClient />
    <modal name="about-change-plan" height="auto" :reset="true">
      <div class="modal-header">
        <h2>{{ $t('label_about-change-plan') }}</h2>
      </div>
      <div class="modal-body">
        <div v-html="$t('html_about-change-plan')"></div>
        <button class="white_btn" @click="hideModal('about-change-plan')">{{ $t('label_close') }}</button>
      </div>
    </modal>
    <modal name="about-business-property-option" height="auto" :reset="true">
      <div class="modal-header">
        <h2>{{ $t('label_about-business-property-option') }}</h2>
      </div>
      <div class="modal-body">
        <div v-html="$t('html_about-business-property-option')"></div>
        <button class="white_btn" @click="hideModal('about-business-property-option')">{{ $t('label_close') }}</button>
      </div>
    </modal>
    <modal name="about-ai-translation-option" height="auto" :reset="true">
      <div class="modal-header">
        <h2>{{ $t('label_about-ai-translation-option') }}</h2>
      </div>
      <div class="modal-body">
        <div v-html="$t('html_about-ai-translation-option')"></div>
        <button class="white_btn" @click="hideModal('about-ai-translation-option')">{{ $t('label_close') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import suspensionNotice from '@/components/client/suspensionNotice'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      },
      aiTranslatingUrl: process.env.VUE_APP_AI_TRANSLATING_URL
    }
  },
  created () {
    this.getPlan({ return_url: location.href }) // カスタマーポータルからの戻り先URLを指定する
  },
  components: {
    navbar,
    footerClient,
    suspensionNotice
  },
  computed: {
    ...mapState(['language']),
    ...mapState('login', ['myAccount']),
    ...mapState('planClient', ['currentPlan', 'nextPlan', 'listing', 'aiTranslating', 'customerPortalUrl', 'listingOptionUrl', 'aiTranslatingOptionUrl']),
    urlLoaded () {
      return this.customerPortalUrl != null
    },
    nextAt () {
      if (this.nextPlan.status === 'canceled' || this.currentPlan.status === 'failed') {
        // 次回更新がキャンセル予定の場合、もしくは現在支払い失敗している場合、次回更新の日程は、なし
        return '-'
      }
      return this.currentPlan.next_at
    }
  },
  methods: {
    ...mapActions('planClient', ['getPlan']),
    openCustomerPortal () {
      if (this.customerPortalUrl) {
        location.href = this.customerPortalUrl
      }
    },
    openInvoice () {
      if (this.currentPlan.invoice_url) {
        location.href = this.currentPlan.invoice_url
      }
    },
    openListingOptionCheckout () {
      if (this.listingOptionUrl) {
        location.href = this.listingOptionUrl
      }
    },
    openAiTranslatingOptionCheckout () {
      if (this.aiTranslatingOptionUrl) {
        location.href = this.aiTranslatingOptionUrl
      }
    },
    toLocaleString ($num) {
      if ($num) {
        return $num.toLocaleString()
      }
      return '0'
    },
    showNextPlan () {
      const $changedPlan = this.currentPlan.name !== this.nextPlan.name
      const $scheduledToCanceledPlan = this.nextPlan.status === 'canceled'
      // プランが変わっている、かつ翌月キャンセルされておらず、今月キャンセル済みでない場合、次回のプランを表示する
      return $changedPlan && !$scheduledToCanceledPlan && this.nextPlan.name
    },
    showCurrentPlan () {
      // 既に契約期間が過ぎた場合以外は表示する
      return this.currentPlan.status !== 'canceled'
    },
    scheduledToCancel () {
      return this.nextPlan.status === 'canceled'
    },
    failedToPay () {
      return this.currentPlan.status === 'failed'
    },
    showModal (name) {
      this.$modal.show(name)
    },
    hideModal (name) {
      this.$modal.hide(name)
    }
  }
}
</script>

<style scoped>
.plan-information h3{
  font-size: 2.5em;
  font-weight: bold;
  margin-top: 80px;
}
.plan-information section:first-of-type h3{
  margin-top: 64px;
}
.plan-information .entry-detail-wrapper{
  margin-top: 40px;
  padding: 24px 40px;
  border: none;
  background-color: #F8F9FA;
}
.plan-information .entry-detail-wrapper .entry-detail-item{
  max-width: none;
  padding: 0;
}

.plan-information .entry-detail-wrapper .entry-detail-item dt,
.plan-information .entry-detail-wrapper .entry-detail-item dd{
  border-top: 1px solid #D5D5D5;
  line-height: 1.5;
  margin-bottom: 0;
  padding: 1em 0;
}
.plan-information .entry-detail-wrapper .entry-detail-item dt:first-of-type,
.plan-information .entry-detail-wrapper .entry-detail-item dd:first-of-type{
  border-top: none ;
}
.plan-information .submit{
  max-width: none;
}
.plan-information .brown_btn{
  max-width: 240px;
}
.plan-information .submit a{
  font-weight: bold;
  margin-left: 40px;
  position: relative;
  padding-left: 40px;
}
.plan-information .submit a::before{
  content: '?';
  color: #fff;
  font-weight: bold;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: absolute;
  margin: auto;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #000;
  text-align: center;
  line-height: 32px;
}
.plan-information .submit{
  justify-content: flex-start;
}
.plan-information .entry-detail-wrapper a{
  text-decoration: underline;
  font-weight: bold;
}
.plan-information .entry-detail-wrapper a:hover{
  text-decoration: none;
}
.plan-information .attention{
  background: #FEF2EF;
  color: #EA6031;
  padding: 1em;
  font-size: .875em;
}
@media screen and (max-width: 768px){
  .plan-information h3{
    font-size: 1.75em;
    margin-top: 48px;
  }
  .plan-information section:first-of-type h3{
    margin-top: 32px;
  }
  .plan-information .entry-detail-wrapper{
    margin-top: 1em;
    padding: 1em;
  }
  .plan-information .entry-detail-wrapper .entry-detail-item{
    display: block;
  }
  .plan-information .entry-detail-wrapper .entry-detail-item dt,
  .plan-information .entry-detail-wrapper .entry-detail-item dd{
    width: 100%;
  }
  .plan-information .entry-detail-wrapper .entry-detail-item dd{
    border-top: none ;
    padding-top: 0;
  }
  .plan-information .submit{
    display: block;
    margin-top: 1em;
  }
  .plan-information .brown_btn{
    font-size: 1.8rem;
    padding: 0.75em 0.25em;
    margin: auto;
    max-width: 343px;
  }
  .plan-information .submit a{
    display: block;
    margin: 1em 0 0;
  }
  .plan-information .entry-detail-wrapper a{
    font-weight: normal;
  }
}
</style>
<style>
.plan-information .attention h4{
  font-weight: bold;
  margin-bottom: .25em;
}
.plan-information .vm--modal{
  max-width: 960px;
}
.plan-information .modal-body h3{
  font-size: 1.25em;
  margin-top: 40px;
  font-weight: bold;
}
.plan-information .modal-body a{
  font-weight: bold;
  color: #BC9B5D;
  text-decoration: underline;
}
.plan-information .modal-body a:hover{
  text-decoration: none;
}
.plan-information .modal-body div > ul,
.plan-information .modal-body p + p{
  margin-top: 2em;
}
.plan-information .modal-body div > ul > li{
  position: relative;
  padding-left: 1em;
  margin-top: 1em;
}
.plan-information .modal-body div > ul > li::before {
    content: '';
    position: absolute;
    top: .5em;
    left: 0;
    width: 6px;
    height: 6px;
    background-color: #BC9B5D;
}
.plan-information .modal-body .annotation,
.plan-information .modal-body .example{
  font-size: .875em;
  margin-top: .5em;
  text-indent: -1em;
  padding-left: 1em;
}
.plan-information .modal-body .example{
  text-indent: -2em;
  padding-left: 2em;
}
.plan-information .modal-body strong{
  color: #EA6031;
}
</style>
